module.exports = __webpack_public_path__ + "img/error.c1f0ff10.png";